import {Component, OnInit} from '@angular/core';
import {AlertController, ModalController} from '@ionic/angular';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {DocumentModel} from '../../models/document.model';
import {BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import {BarcodeOptions} from '../../definitions/barcode-options';
import {PersistScannedBarcodesService} from '../../services/persist-scanned-barcodes.service';
import {ScanBarcodeService} from '../../services/scan-barcode.service';
import {GeneralService} from '../../services/general.service';
import {ContractCreationFromCollectionHealtcareService} from '../../services/contract-creation-from-collection-healtcare.service';
import {DocumentFromLiveDetailLineService} from '../../services/document-from-live-detail-line.service';

@Component({
    selector: 'app-detail-lines-to-be-collected',
    templateUrl: './detail-lines-to-be-collected.component.html',
    styleUrls: ['./detail-lines-to-be-collected.component.scss'],
})
export class DetailLinesToBeCollectedComponent implements OnInit {
    collectionDetailLines: DetaillineDTOModel[];
    liveLinesBarcode = [];
    currentCollectionsInPhone: DocumentModel[];
    manualInput: string;

    constructor(public modalController: ModalController,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private barcodeScanner: BarcodeScanner,
                private barcodeOptions: BarcodeOptions,
                private persistScannedBarcodesService: PersistScannedBarcodesService,
                private scanBarcodeService: ScanBarcodeService,
                private alertController: AlertController,
                private generalService: GeneralService,
                private contractCreationFromCollectionHealtcareService: ContractCreationFromCollectionHealtcareService,
                private documentFromLiveDetailLine: DocumentFromLiveDetailLineService) {
    }

    ngOnInit() {
        this.collectionDetailLines = [];
        this.populateCollectionDetailLines();
        const linesTest = this.stateManager.getCollection(this.collectionNames.LIVEDETAILLINES).filter(line => line.site === 45);
        console.log(linesTest);
    }

    private populateCollectionDetailLines() {
        const documentsList = [];
        this.currentCollectionsInPhone = [];
        for (const doc of this.stateManager.getCollection(this.collectionNames.DOCUMENT) as DocumentModel[]) {
            documentsList.push(doc.documentNumber);
            if ((doc.documentType === 8 && doc.originalDocumentType === 7) || doc.documentType === 2) {
                this.collectionDetailLines = [...this.collectionDetailLines, ...doc.detailLines];
                this.currentCollectionsInPhone.push(doc);
            }
        }
        for (const doc of this.stateManager.getCollection(this.collectionNames.QUEUEDDOCUMENTS) as DocumentModel[]) {
            if ((!documentsList.includes(doc.documentNumber) && doc.documentType === 8 && doc.originalDocumentType === 7)
                || doc.documentType === 2) {
                this.collectionDetailLines = [...this.collectionDetailLines, ...doc.detailLines];
                this.currentCollectionsInPhone.push(doc);
            }
        }
        console.log(this.collectionDetailLines);
    }

    async scanCode() {
        this.barcodeScanner.scan(this.barcodeOptions.options).then(barcode => {
            console.log(barcode.text);
            this.handleScanResult(barcode.text);
        }).catch(err => {
            console.log(err);
        });
        // const modal = await this.modalController.create({
        //     component: CollectionWithBarcodeComponent,
        //     backdropDismiss: false,
        //     cssClass: 'modal-fullscreen',
        //     componentProps: {}
        // });
        // modal.onDidDismiss().then(() => {
        //     this.ngOnInit();
        // });
        // return await modal.present();
    }

    async handleScanResult(event) {
        console.log('Scan Result');
        console.log(event);
        this.manualInput = null;
        for (const doc of this.currentCollectionsInPhone) {
            if ((doc.documentType === 8 && doc.originalDocumentType === 7) || doc.documentType === 2) {
                for (const line of doc.detailLines) {
                    if (line.barcode === event) {
                        this.persistScannedBarcodesService.persistBarcode(event);
                        this.confirmEquipment(line, doc, 1);
                        return;
                    }
                }
            }
        }
        const returnDetailLine = this.scanBarcodeService.findLiveLineByBarcode(event) as DetaillineDTOModel;
        if (returnDetailLine) {
            await this.persistScannedBarcodesService.persistBarcode(event);
            this.handleDetailLine(JSON.parse(JSON.stringify(returnDetailLine)));
            // If line found and processing a changeover it means I found the broken item
           
        } else {
            await this.generalService.createToast('No match with barcode: ' + event);
        }
    }

    async confirmEquipment(equipment, document, index) {
        // Index 1 is for existing collections
        // Index 2 is for new collections
        let msg = '';
        let header = '';
        if (index === 3) {
            header = 'Equipment not in contract';
            msg = 'Do you want to create a contract AND a cancelation for \n' + equipment.description + '?';
        } else {
            header = 'Equipment found';
            msg = 'Do you want to cancel \n' + equipment.description + '?';
        }
        const alert = await this.alertController.create({
            header: header,
            message: msg,
            backdropDismiss: false,
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                }, {
                    text: 'Yes',
                    handler: () => {
                        if (index === 1) {
                            this.handleEquipmentFoundWithBarcode(equipment, document);
                        }
                        if (index === 2) {
                            this.createNewCollectionForItem(equipment);
                            this.populateCollectionDetailLines(); // its a new line gota refresh

                        }
                        if (index === 3) {
                            this.contractCreationFromCollectionHealtcareService.handleContractCreation(equipment);
                            this.populateCollectionDetailLines(); // its a new line gota refresh
                        }
                    }
                }
            ]
        });
        await alert.present();
    }

    async handleEquipmentFoundWithBarcode(equipment: DetaillineDTOModel, doc: DocumentModel) {
        if (equipment.requiredQty) {
            equipment.qty = equipment.requiredQty;
        }
        if (doc.documentNumber !== 0 && !this.isInDocumentCollection(doc)) {
            delete doc.$loki;
            delete doc.meta;
        }
        this.stateManager.upsert(this.collectionNames.DOCUMENT, '$loki', doc);
        this.stateManager.saveDatabase();
    }

    async createNewCollectionForItem(equipment: DetaillineDTOModel) {
        console.log(equipment);
        this.documentFromLiveDetailLine.newCollection(equipment);
    }

    private isInDocumentCollection(doc: DocumentModel) {
        for (const inCollDoc of this.stateManager.getCollection(this.collectionNames.DOCUMENT)) {
            if (inCollDoc.documentNumber === doc.documentNumber) {
                return true;
            }
        }
        return false;
    }

    private handleDetailLine(detailLine: DetaillineDTOModel) {
        if (detailLine.stat !== 200) {
            this.confirmEquipment(detailLine, null, 2);
      
        } else {
            this.confirmEquipment(detailLine, null, 3);

        }
    }
}
